import { z } from 'zod';
import { optionalNullableDateInput, optionalUuidString } from '../zod-helpers/index.js';
import { PURCHASE_ORDER_CONSTRAINTS } from './constraints.js';
export const updatePurchaseOrderInputSchema = z.object({
    note: z
        .string()
        .max(PURCHASE_ORDER_CONSTRAINTS.note.maxLength, `${PURCHASE_ORDER_CONSTRAINTS.note.label} must be ${PURCHASE_ORDER_CONSTRAINTS.note.maxLength} characters or fewer.`)
        .optional()
        .nullable(),
    locationGroupId: optionalUuidString(`Invalid ${PURCHASE_ORDER_CONSTRAINTS.locationGroup.label.toLowerCase()} selection.`)
        .optional()
        .nullable(),
    deliverTo: z
        .string()
        .max(PURCHASE_ORDER_CONSTRAINTS.deliverTo.maxLength, `${PURCHASE_ORDER_CONSTRAINTS.deliverTo.label} must be ${PURCHASE_ORDER_CONSTRAINTS.deliverTo.maxLength} characters or fewer.`)
        .optional()
        .nullable(),
    shipToName: z
        .string()
        .max(PURCHASE_ORDER_CONSTRAINTS.shipToName.maxLength, `${PURCHASE_ORDER_CONSTRAINTS.shipToName.label} must be ${PURCHASE_ORDER_CONSTRAINTS.shipToName.maxLength} characters or fewer.`)
        .optional()
        .nullable(),
    shipToAddress: z
        .string()
        .max(PURCHASE_ORDER_CONSTRAINTS.shipToAddress.maxLength, `${PURCHASE_ORDER_CONSTRAINTS.shipToAddress.label} must be ${PURCHASE_ORDER_CONSTRAINTS.shipToAddress.maxLength} characters or fewer.`)
        .optional()
        .nullable(),
    shipToCity: z
        .string()
        .max(PURCHASE_ORDER_CONSTRAINTS.shipToCity.maxLength, `${PURCHASE_ORDER_CONSTRAINTS.shipToCity.label} must be ${PURCHASE_ORDER_CONSTRAINTS.shipToCity.maxLength} characters or fewer.`)
        .optional()
        .nullable(),
    shipToZip: z
        .string()
        .max(PURCHASE_ORDER_CONSTRAINTS.shipToZip.maxLength, `${PURCHASE_ORDER_CONSTRAINTS.shipToZip.label} must be ${PURCHASE_ORDER_CONSTRAINTS.shipToZip.maxLength} characters or fewer.`)
        .optional()
        .nullable(),
    dateFirstShip: optionalNullableDateInput,
    dateConfirmed: optionalNullableDateInput,
});
//# sourceMappingURL=update-input.js.map